import { render, staticRenderFns } from "./Email-news.vue?vue&type=template&id=67aa4920"
import script from "./Email-news.vue?vue&type=script&lang=js"
export * from "./Email-news.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports